export default {
  unexpectedError: log => {
    alert("😬 Oops unexpected error.");
    window.l = log;
    console.log(log);
  }
};



// WEBPACK FOOTER //
// ./src/utils/alert.js